import { render, staticRenderFns } from "./TagPills.vue?vue&type=template&id=3a9c8deb&"
import script from "./TagPills.vue?vue&type=script&lang=js&"
export * from "./TagPills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports